module.exports = __webpack_public_path__ + "media/semantic/dist/themes/default/assets/fonts/brand-icons-0cb5a5c0d251c109458c85c6afeffbaa.svg";